class WarehouseInState {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'WarehouseInState'

export const DEVIANT = new WarehouseInState(-1, '进仓异常', 'deviant')
export const NOT_IN = new WarehouseInState(0, '未进仓', 'not in')
export const PART_IN = new WarehouseInState(1, '部分进仓', 'part in')
export const ALL_IN = new WarehouseInState(2, '全部进仓', 'all in')

export const WAREHOUSE_IN_STATE = [DEVIANT, NOT_IN, PART_IN, ALL_IN]

export const OUT_TYPE_FLIGHT_SHIPMENT = new WarehouseInState('FLIGHT', '航班出运', 'Flight shipment')
export const OUT_TYPE_CUSTOMER_PICK_UP = new WarehouseInState('CUSTOMER', '客户自提', 'Customer pick up')

export const WAREHOUSE_IN_OUT_TYPE = [OUT_TYPE_FLIGHT_SHIPMENT, OUT_TYPE_CUSTOMER_PICK_UP]

// 入库状态
export const UN_WAREHOUSING = new WarehouseInState(0, '未入库', 'Not received')
export const PARTIAL_WAREHOUSING = new WarehouseInState(1, '部分入库', 'Partial warehousing')
export const FULLY_STORED = new WarehouseInState(2, '完全入库', 'Fully stored')
export const WAREHOUSE_STATE = [UN_WAREHOUSING, PARTIAL_WAREHOUSING, FULLY_STORED]

export const WAREHOUSE_IN_STATE_3 = new WarehouseInState(3, '已收货', 'Received')
export const WAREHOUSE_IN_STATE_4 = new WarehouseInState(4, '入仓完成', 'done')
export const WAREHOUSE_STATE_LIST = [UN_WAREHOUSING, WAREHOUSE_IN_STATE_3, WAREHOUSE_IN_STATE_4]
